export enum DndType {
    SpellAssignment = "SpellAssignment",
    TeamAssignment = "TeamAssignment"
}

type SpellAssignmentPayload = {
    payload: {
        playerId: string
        spellId: string
        eventOffset: number
    }
}

export function makeSpellDndItem(payload: Omit<SpellAssignmentPayload, 'type'>) {
    return {
        type: DndType.SpellAssignment,
        ...payload
    }
}

export function isSpellAssignmentDndItem(item: any): item is SpellAssignmentPayload {
    if (item.type === DndType.SpellAssignment) {
        return true
    }

    return false
}
